// 共享的登录态标记：记录当前 token 是否已被后端校验过有效性。
// 单独抽成模块，避免 router/index.ts 与 utils/request.ts 互相 import 造成循环依赖。

let tokenValidated = false;

export const isTokenValidated = (): boolean => tokenValidated;

export const setTokenValidated = (value: boolean): void => {
  tokenValidated = value;
};

// 会话中途 token 失效（401/403）后调用，使下次进入守卫时重新向后端校验
export const resetTokenValidated = (): void => {
  tokenValidated = false;
};
